import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Theme } from '@mui/material/styles';

import TeamPanel from './TeamPanel';
import {BaseCard} from '../../../components/wizard';
import { extendedstyles } from '../../appstyles';

const s:any ={
  root: {
    width: '100%',
    display: 'flex',
    // overflow: 'scroll',
    justifyContent: 'space-between'
  },
  panel: {
    flex: '1 1 auto'
  },
};

class TeamCard extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.props.deb.log("UserCard");
    this.state = {
      next: true,
      idtype: null,
      idfrom: null,
      fwopen: false
    };
  }

  render = () => {
    const { classes, theme, ...extraProps  } = this.props;
    const {record,data,extras,formdata,setItem} = this.props;
    return (
      <BaseCard
        cardid={'TEAM'}
        cardname={'Team'}
        cardtitle={'Team'}
        instruction={'Provide details about the inspection Team'}
        step={2}
        buttons={['START','CANCEL','PREV','NEXT','GUIDE']}
        {...extraProps}
      >
        <TeamPanel 
          data={extraProps.data}
          //record={record} 
          record={{...record,...formdata}}
          extras={extras}
          setItem={setItem}
          />
      </BaseCard>
    );
  }
}

TeamCard.propTypes = {
  //classes: PropTypes.object.isRequired,
};

export default TeamCard;
